import { Injector } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { FsAnalytics } from '@firestitch/analytics';
import { DisplayApiError, FsApiConfig, makeInterceptorFactory, ProcessApiError } from '@firestitch/api';
import { FsCookie } from '@firestitch/cookie';
import { FsErrorMessage } from '@firestitch/message';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
} from '@angular/common/http';

import { ApiService, SigninService } from '..';
import { ENVIRONMENT } from '../injectors';


export class ApiInterceptor implements HttpInterceptor {

  public readonly API_ERROR_RESOURCE_NOT_FOUND = 404;
  public readonly API_ERROR_INVALID_AUTHORIZATION = 490;

  private _environment: any;
  private _apiService: ApiService;

  constructor(
    public config: FsApiConfig,
    public data,
    private _injector: Injector,
  ) {
    this._apiService = this._injector.get(ApiService);
    this._environment = this._injector.get(ENVIRONMENT);
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = this._environment.apiPath.concat(req.url);

    if (this._environment.apiDomain) {
      url = `https://${this._environment.apiDomain}`.concat(url);
    }

    let headers = req.headers;

    if (this._apiService.sameSite !== 'Lax') {
      headers = headers.append('Same-Site', this._apiService.sameSite);
    }

    const xsrf = this._injector.get(FsCookie).get('Token-XSRF');

    if (xsrf) {
      headers = headers.append('Token-XSRF', xsrf);
    }

    return next.handle(req.clone({ url, headers }))
      .pipe(
        catchError((event: HttpErrorResponse) => {
          if (this.config.context?.get(ProcessApiError) ?? true) {
            if (event.status === this.API_ERROR_RESOURCE_NOT_FOUND) {
              this._injector.get(Router).navigateByUrl('/notfound');
            } else if (event.status === this.API_ERROR_INVALID_AUTHORIZATION) {
              this._injector.get(MatDialog).closeAll();
              this._injector.get(SigninService).navigateSignin();
            } else if (this.config.context?.get(DisplayApiError) ?? true) {
              this._injector.get(FsErrorMessage).processHttpErrorResponse(event);
            }
          }

          if (event.status !== this.API_ERROR_INVALID_AUTHORIZATION) {
            this._injector.get(FsAnalytics).trackEvent('exception', {
              status: event.status,
              url: req.url,
              method: req.method,
            });
          }

          return throwError(() => event);
        }),
      );
  }
}

export const ApiInterceptorFactory = makeInterceptorFactory(ApiInterceptor);
